import { combineReducers } from 'redux';
import { reducer as languageReducer } from './slice';

const rootReducer = combineReducers({
  language: languageReducer, 
  
});

export default rootReducer;